var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{enlarged:this.$bus.sidebarStatus},attrs:{"id":"layout-default"}},[_c('top-bar'),_c('side-bar',{attrs:{"slide-menu-items":_vm.slideMenuItems}}),_c('content-wrap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }